import Link from 'next/link';
import type { ReactNode } from 'react';

interface BreadcrumbLinkProps {
  children: ReactNode;
  href?: string;
  active?: boolean;
  className?: string;
}

export function BreadcrumbLink({
  children,
  href,
  active = false,
  className = '',
}: BreadcrumbLinkProps) {
  const baseClasses =
    'flex flex-col items-center justify-center px-0 py-1 text-xs font-normal leading-4 whitespace-nowrap';

  const textClasses = active ? 'text-secondary' : 'text-accent hover:underline';

  const combinedClasses = `${baseClasses} ${textClasses} ${className}`;

  if (href && !active) {
    return (
      <Link href={href} className={combinedClasses}>
        {children}
      </Link>
    );
  }

  return <span className={combinedClasses}>{children}</span>;
}
